import React from 'react';
import styled from 'styled-components';
import { PlusOutlined } from '@ant-design/icons';
import Button from 'components/forms/Button';
import InputWithSelectRow from './InputWithSelectRow';
import TotalRow from './TotalRow';
import SectionHeader from './SectionHeader';
import './occupiedRoom.style.css';

const Title = styled.h2`
    font-family: ${({ theme }) => theme.font.title};
    font-size: 1.9em;
    color: ${({ theme }) => theme.colour.dark};
    text-align: left;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
`;

const CostsList = ({
    formData,
    currency,
    sectionName,
    texts,
    onToggleSection,
    onToggleField,
    onChangeFieldName,
    onChangeFieldValue,
    onChangeFieldPercentage,
    onAddSectionItem,
    onRemoveSectionItem,
    allowTogglingItems = true,
    hidePercentage = false,
    allowDeletingPresets = true,
    selectStyles = {},
}) => {
    const { daysOpenPerPeriod } = formData.roomBreakdown;
    return (
        <>
            <Title>{texts.title}</Title>
            <hr style={{ marginBottom: '2em' }} />
            <SectionHeader
                sectionTitle=""
                enabled={formData.sections[sectionName]}
                onToggle={(checked) => onToggleSection(sectionName, checked)}
                hideSelect={hidePercentage}
                daysOpenPerPeriod={daysOpenPerPeriod}
            />
            {formData[sectionName].map((row) => (
                <InputWithSelectRow
                    key={row.id}
                    editableTitle={!row.isPreset}
                    title={row.name}
                    onChangeTitle={(value) => onChangeFieldName(sectionName, row.id, value)}
                    hideToggle={!allowTogglingItems}
                    enabled={row.applied}
                    onToggleFieldEnabled={(checked) => onToggleField(sectionName, row.id, checked)}
                    grossValue={row.value}
                    onChangeGrossValue={(value) => onChangeFieldValue(sectionName, row.id, value)}
                    hideSelect={hidePercentage}
                    percentage={row.percentage}
                    onChangeFieldPercentage={(value) => onChangeFieldPercentage(sectionName, row.id, value)}
                    netValue={row.amount}
                    currency={currency}
                    showDeleteIcon={allowDeletingPresets ? true : !row.isPreset}
                    removeItem={() => onRemoveSectionItem(sectionName, row.id)}
                    selectStyles={selectStyles}
                />
            ))}
            <Button id="button" size="default" icon={<PlusOutlined />} onClick={() => onAddSectionItem(sectionName)}>
                {texts.addBtn}
            </Button>
            <TotalRow label={texts.title} currency={currency} formData={formData[sectionName]} />
        </>
    );
};

export default CostsList;
